import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import { cTextSprite } from '../creator/cGameObjects/cTextSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';

const emitterConfig:any = {
  alpha: { start: 1, end: 0, ease: 'Cubic.easeIn' },
  angle: { start: 0, end: 360, steps: 100 },
  blendMode: 'ADD',
  frame: { frames: ['red', 'yellow', 'green', 'blue'], cycle: true, quantity: 500 },
  frequency: 2000,
  gravityY: 400,
  lifespan: 1200,
  quantity: 400,
  reserve: 500,
  scale: { min: 0.1, max: 0.35 },
  speed: { min: 300, max: 900 },
  x: 512, y: 384,
};


export class gameFairDisplay extends cDisplay {

  private curScreen: cInlineDisplay
  private curSelected: any;
  private dropitems:any[]
  private emitters:any[]

  init(){
    super.init()
    console.log('INIT FAIR 1');

    this.curSelected = null;
    this.dropitems = [];

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      
      switch (b.command){
        case 'fireworks':
          var cc = 3;
          var ref = this.getByName('firework_pos');
          var $this = this;
          this.emitters = [];
          var cc = 1;
          const createFireworks = ()=>{
            console.log('FIREWORKS')
            const particles = this.scene.add.particles('flares');
            emitterConfig.x = ref.x
            emitterConfig.y = ref.y
            emitterConfig.emitCallback = (e)=>{
              if (cc == 1){
                cc = 0;
                e.emitter.frequency = 800 + Math.floor(Math.random() * 2200);
                console.log(e);
                (this.scene as cScene).snd('audio_fireworks',{})
                setTimeout(()=>{
                  cc = 1;
                },100)
                console.log('EIIT')
              }
            }
            const emitter = particles.createEmitter(emitterConfig);
            $this.emitters.push(emitter);
            //if (cc-- > 0) setTimeout(createFireworks, 1500+ Math.random() * 800);
          }
          createFireworks();
          break;
        case 'bump':
          this.y = 10;
          this.scene.tweens.add({
            targets:[this],
            y: 0,
            ease: 'Bounce.easeOut',
            duration: 800,            
          })
          break;
        case 'close':
          this.emitters.forEach( (e)=>{
            e.destroy()
          })
          break;
        case 'show_panels':
          console.log('SHOW PANELS');
          this.createItems();
          break;
        case 'return_item':
          this.returnToPosition(this.curSelected);
          break;
      }

    })

  }

  buildScene(){    
    super.buildScene();
    //setTimeout(()=>this.setupDragging(),10)


  }

  createItems(){
    var d:string[] = (this.getByName('DATA') as cSprite).modules.data._extraData
    var ref: cTextSprite = this.getByName('_rightPanel');
    var holder: cContainer = this.getByName('items_holder');
    var cS:cScene = this.scene as cScene;

    d = d.sort(()=>Math.random()-0.5);    
    d.forEach( (s,i)=>{
      
      var nData = {...ref.modules.data.data};
      var yy = Math.floor(i / 3);
      var xx = (i-(yy*3));
      var textPos = nData.initProps.textpos

      nData.name = 'item_'+i;
      nData.text = s;
      nData.ofs = ((xx*480)+460) +'x' + ((yy*120)+90);
      nData.animoptions.delay = i*50
      nData.initProps = {
        angle: String((Math.random()*10) - 5),
        textpos: textPos
      }

      var n = new cTextSprite(this.scene as cScene,nData);
      holder.add(n);

      n.setInteractive({
        hitArea: new Phaser.Geom.Rectangle(-200, -40, 400, 80),
        hitAreaCallback: Phaser.Geom.Rectangle.Contains,
        draggable: true,
        useHandCursor: true        
      });      
      cS.input.setDraggable( n )
    })
    this.setupDragging();

  }


  setupDragging(){
   
    var dropTarget:cSprite = this.getByName('droparea');
    var cS:cScene = this.scene as cScene;

    cS.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
      gameObj.x = Math.round(x);
      gameObj.y = Math.round(y);
    });

    cS.input.on('dragend',(p:any, gameObj:any)=>{
      let ref:cSprite = gameObj as cSprite;

      var pos = new Phaser.Geom.Point( ref.x, ref.y )
      var rect = dropTarget.getBounds()

      if (Phaser.Geom.Rectangle.ContainsPoint(rect,pos)){
        this.removeItem(ref);
      }else{
        this.returnToPosition(ref)
      }
    })    
  }

  returnToPosition(ref){
    var orgPos =  ref.modules.layout.getOfs( ref.modules.data.data.ofs )
    var cS:cScene = this.scene as cScene;
    cS.tweens.add({
      targets: ref,
      ease: 'Back.easeOut',
      duration: 400,
      x: orgPos.x,
      y: orgPos.y
    });
  }

  wubble(){
    var cc = 10
    var si = 10
    var $this = this
    var idd = setInterval( ()=>{
      this.x = (Math.random() * (si+si)) - si
      this.y = (Math.random() * (si+si)) - si
      if (cc-- == 0){
        clearInterval(idd)
        this.x = 0;
        this.y = 0;
        } 
    },30)
  }


  removeItem(ref){
    var holder: cContainer = this.getByName('items_holder');
    var cS:cScene = this.scene as cScene;
    cS.tweens.add({
      targets: ref,
      ease: 'Back.easeIn',
      duration: 600,
      scale: 0.2,
      alpha: 0,
      onComplete:()=>{
        this.wubble();
        this.dropitems.push(ref.name);        
        var h: cSprite = this.getByName('vg_hammer_large')

        
        var f = 'audio_slot_'+(this.dropitems.length);
        console.log(f);
        (this.scene as cScene).snd(f)


        h.setFrame('head_'+ this.dropitems.length )
        if (this.dropitems.length === 5){
          cS.triggerSceneEvent('hammer_full',{name:ref.name});
        }

      }
    });


    // holder.remove(ref);
    // ref.destroy();

  }


}
